import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/onboarding')({
  staticData: { team: 'fe-clm' },
});
